(ns common.specs.note
  (:require [clojure.spec.alpha :as s]

            [common.specs.universal]))

(s/def :note/note-uuid :common/uuid)
(s/def :note/activity-uuid :common/uuid)
(s/def :note/user-uuid :common/uuid)
(s/def :note/content string?)

(s/def ::time-valid #(and (= (:type %) "time")
                          (-> %
                              :value
                              number?)))
(s/def ::moment-resource-valid #(and (or (= (:type %) "moment")
                                         (= (:type %) "resource"))
                                     (-> %
                                         :value
                                         string?)))

(s/def :note/metadata #(if (= (:type %) "time")
                         (s/valid? ::time-valid %)
                         (s/valid? ::moment-resource-valid %)))
